var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUptimerobot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 298,
    height: 298,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#3BD771",
    transform: "translate(.9 .9)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 148.1,
    cy: 148.1,
    r: 148.1,
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.1,
    cy: 148.1,
    r: 98.9
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUptimerobot);
export default __webpack_public_path__ + "static/media/uptimerobot.ac35e70aadf846dd67fc8c7a00a468e2.svg";
export { ForwardRef as ReactComponent };